/* tslint:disable */
/* eslint-disable */
/**
 * VoresAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateBusinessCtaLeadForm
 */
export interface CreateBusinessCtaLeadForm {
    /**
     *
     * @type {string}
     * @memberof CreateBusinessCtaLeadForm
     */
    businessId: string;
    /**
     *
     * @type {string}
     * @memberof CreateBusinessCtaLeadForm
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof CreateBusinessCtaLeadForm
     */
    phone: string;
    /**
     *
     * @type {string}
     * @memberof CreateBusinessCtaLeadForm
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof CreateBusinessCtaLeadForm
     */
    message?: string;
    /**
     *
     * @type {string}
     * @memberof CreateBusinessCtaLeadForm
     */
    recaptcha: string;
}

export function CreateBusinessCtaLeadFormFromJSON(json: any): CreateBusinessCtaLeadForm {
    return CreateBusinessCtaLeadFormFromJSONTyped(json, false);
}

export function CreateBusinessCtaLeadFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBusinessCtaLeadForm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'businessId': json['businessId'],
        'name': json['name'],
        'phone': json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'recaptcha': json['recaptcha'],
    };
}

export function CreateBusinessCtaLeadFormToJSON(value?: CreateBusinessCtaLeadForm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'businessId': value.businessId,
        'name': value.name,
        'phone': value.phone,
        'email': value.email,
        'message': value.message,
        'recaptcha': value.recaptcha,
    };
}
